import { useRouter } from 'next/router';
import { ReactElement } from 'react';
import { LanguageCode } from '@Hotels-at-Home/hah-fe-core/dist/constants';

interface IProps {
  normalText: string;
  children: ReactElement;
  flipList?: string[];
  alternateFlip?: boolean;
}
// Utility Component for flipping text and styled elements of Marriott titles according to language
const TitleFlip = ({
  normalText,
  children,
  flipList = ['fr', 'es'],
  alternateFlip = false,
}: IProps) => {
  const router = useRouter();
  const locale = router.locale as LanguageCode;
  let elementsList = [normalText, children];
  if (alternateFlip) {
    elementsList = elementsList.reverse();
  }

  return flipList.includes(locale) ? (
    <>
      {elementsList[1]}
      &nbsp;
      {elementsList[0]}
    </>
  ) : (
    <>
      {elementsList[0]}
      &nbsp;
      {elementsList[1]}
    </>
  );
};

export default TitleFlip;
